import { render, staticRenderFns } from "./Lgx240444036513529856.vue?vue&type=template&id=0f00ea36&scoped=true&"
import script from "./Lgx240444036513529856.vue?vue&type=script&lang=js&"
export * from "./Lgx240444036513529856.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f00ea36",
  null
  
)

export default component.exports